import React, { Component } from "react";
import {
    TextField, Button, Checkbox, FormControlLabel,
    Autocomplete, RadioGroup, Radio, Typography,
    Divider, Paper, Dialog, DialogTitle,
    DialogContent, DialogActions, AppBar, Toolbar, IconButton
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Box from "@mui/material/Box";
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';

const cookies = new Cookies();

export default class InvoiceForm extends Component {
    state = {
        traderName: null,
        date: "",
        transportCost: "",
        notes: "",
        paymentType: "cash",
        deferredAmount: "",
        includeShippingInDeferred: false,
        items: [this.createEmptyItem()],
        traderNames: [],
        products: [],
        deviceTypes: [],
        openProductDialog: false,
        newProductName: "",
        isSaving: false
    };

    createEmptyItem() {
        return {
            product: null,
            quantity: 0,
            price: 0,
            deviceType: [],
        };
    }

    componentDidMount() {
        const header = {
            "Content-Type": "application/x-www-form-urlencoded",
            token: cookies.get("token")
        };

        axios.get(host + `dashbord/Suppliers/all`, { headers: header })
            .then(res => {
                const traderNames = res.data.suppliers.map(s => ({
                    label: s.name,
                    id: s.id
                }));
                this.setState({ traderNames });
            });

        axios.get(host + `dashbord/items/get/all?type=2`, { headers: header })
            .then(res => {
                const deviceTypes = res.data.items.map(item => ({
                    label: item.name,
                    id: item.id
                }));
                this.setState({ deviceTypes });
            });

        axios.get(host + `users/new_prats/`, { headers: header })
            .then(res => {
                const products = res.data.parts.map(item => ({
                    label: item.name,
                    id: item.id
                }));
                this.setState({ products });
            });
    }

    handleChange = (index, field, value) => {
        const items = [...this.state.items];
        items[index][field] = value;
        this.setState({ items });
    };

    addItem = () => {
        this.setState({ items: [...this.state.items, this.createEmptyItem()] });
    };

    removeItem = (index) => {
        const items = [...this.state.items];
        items.splice(index, 1);
        this.setState({ items });
    };

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({ [name]: type === "checkbox" ? checked : value });
    };

    handleOpenProductDialog = () => {
        this.setState({ openProductDialog: true, newProductName: "" });
    };

    handleCloseProductDialog = () => {
        this.setState({ openProductDialog: false });
    };

    handleSaveNewProduct = () => {
        const { newProductName } = this.state;
        axios.post(host + `users/new_prats/new/`, { name: newProductName })
            .then(() => {
                this.componentDidMount();
                this.setState({ openProductDialog: false, newProductName: "" });
                window.alert('تم حفظ المادة بنجاح');
            })
            .catch(() => window.alert('حدث خطأ'));
    };

    saveInvoice = () => {
        const {
            traderName, date, transportCost, items,
            paymentType, deferredAmount, notes
        } = this.state;

        if (!traderName || !date || !transportCost) {
            alert("يرجى تعبئة جميع الحقول الرئيسية للفاتورة.");
            return;
        }

        if (paymentType === "deferred" && !deferredAmount) {
            alert("يرجى إدخال مبلغ الدفع بالآجل.");
            return;
        }

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (!item.product || !item.quantity || !item.price || item.deviceType.length === 0) {
                alert(`يرجى تعبئة جميع بيانات المادة رقم ${i + 1}`);
                return;
            }
        }

        const totalPrice = items.reduce((acc, item) => acc + Number(item.quantity) * Number(item.price), 0);
        const invoiceData = {
            traderName,
            date,
            transportCost,
            notes,
            totalPrice,
            paymentType,
            deferredAmount: paymentType === "deferred" ? deferredAmount : null,
            includeShippingInDeferred: this.state.includeShippingInDeferred,
            items,
        };

        this.setState({ isSaving: true });

        const header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("tokenUser") };

        axios.post(host + `dashbord/bill/parts/new`, {
            list: JSON.stringify(invoiceData),
        })
            .then(() => {
                alert("تم حفظ الفاتورة بنجاح!");
                this.setState({ isSaving: false });
                // window.location.href = "/billsList";
            })
            .catch(() => {
                alert("حدث خطأ أثناء حفظ الفاتورة");
                this.setState({ isSaving: false });
            });
    };

    render() {
        const {
            traderName, date, transportCost, notes, paymentType,
            deferredAmount, includeShippingInDeferred, items,
            traderNames, products, deviceTypes,
            openProductDialog, newProductName, isSaving
        } = this.state;

        const totalQuantity = items.reduce((acc, item) => acc + Number(item.quantity), 0);
        const totalPrice = items.reduce((acc, item) => acc + Number(item.quantity) * Number(item.price), 0);
        const deferredRemaining = paymentType === "deferred" ? totalPrice - Number(deferredAmount || 0) : 0;

        return (
            <Box dir="rtl">
                <AppBar position="static" sx={{ backgroundColor: "#000" }}>
                    <Toolbar sx={{ justifyContent: "space-between" }}>
                        <Box />
                        <Typography variant="h6" sx={{ color: "#fff", flexGrow: 1, textAlign: "center" }}>
                            إنشاء فاتورة
                        </Typography>
                        <IconButton edge="end" color="inherit" onClick={() => window.history.back()}>
                            <ArrowBackIosNewIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <Paper elevation={4} sx={{ p: 4, maxWidth: 950, margin: "40px auto", borderRadius: 5 }}>
                    <Typography variant="h4" align="center" gutterBottom>🧾 انشاء فاتورة قطع غيار</Typography>
                    <Divider sx={{ my: 3, borderColor: "#bbb" }} />

                    <Autocomplete
                        options={traderNames}
                        value={traderName}
                        onChange={(e, newValue) => this.setState({ traderName: newValue })}
                        getOptionLabel={(option) => option?.label || ""}
                        renderInput={(params) => <TextField {...params} label="اسم التاجر" sx={{ mb: 2 }} />}
                    />
                    <TextField fullWidth label="تاريخ الادخال" type="date" name="date" value={date} onChange={this.handleInputChange} InputLabelProps={{ shrink: true }} sx={{ mb: 2 }} />
                    <TextField fullWidth label="تكلفة النقل" name="transportCost" value={transportCost} onChange={this.handleInputChange} type="number" sx={{ mb: 2 }} />
                    <TextField fullWidth label="ملاحظات" name="notes" value={notes} onChange={this.handleInputChange} multiline rows={3} sx={{ mb: 3 }} />

                    <Button variant="outlined" color="secondary" onClick={this.handleOpenProductDialog} sx={{ mb: 2 }}>
                        ➕ إضافة بطاقة مادة جديدة
                    </Button>

                    <Typography variant="h6" gutterBottom>📦 تفاصيل المواد</Typography>
                    {items.map((item, index) => (
                        <Box key={index} sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
                            <Autocomplete
                                options={products}
                                value={item.product}
                                onChange={(e, newValue) => this.handleChange(index, "product", newValue)}
                                getOptionLabel={(option) => option?.label || ""}
                                renderInput={(params) => <TextField {...params} label="اسم المنتج" />}
                                sx={{ minWidth: 200, flex: 1 }}
                            />
                            <TextField label="العدد" type="number" value={item.quantity} onChange={(e) => this.handleChange(index, "quantity", e.target.value)} sx={{ width: 100 }} />
                            <TextField label="سعر القطعة" type="number" value={item.price} onChange={(e) => this.handleChange(index, "price", e.target.value)} sx={{ width: 120 }} />
                            <Autocomplete
                                multiple
                                options={deviceTypes}
                                value={item.deviceType}
                                onChange={(e, newValue) => this.handleChange(index, "deviceType", newValue)}
                                getOptionLabel={(option) => option?.label || ""}
                                renderInput={(params) => <TextField {...params} label="نوع الجهاز" />}
                                sx={{ minWidth: 180 }}
                            />
                            <Button color="error" variant="outlined" onClick={() => this.removeItem(index)}>حذف</Button>
                        </Box>
                    ))}

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2, mb: 3 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={includeShippingInDeferred}
                                    onChange={this.handleInputChange}
                                    name="includeShippingInDeferred"
                                />
                            }
                            label="تضمين مصاريف الشحن (لا يؤثر على السعر)"
                            sx={{ mr: "auto" }}
                        />
                        <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
                        <Button variant="outlined" onClick={this.addItem} sx={{ ml: "auto" }}>
                            ➕ اضافة مادة جديدة
                        </Button>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <RadioGroup row name="paymentType" value={paymentType} onChange={this.handleInputChange} sx={{ mb: 3 }}>
                        <FormControlLabel value="cash" control={<Radio defaultChecked />} label="الدفع نقداً" />
                        <FormControlLabel value="transfer" control={<Radio />} label="دفع عن طريق حوالة" />
                        <FormControlLabel value="deferred" control={<Radio />} label="الدفع بالآجل" />
                    </RadioGroup>

                    {paymentType === "deferred" && (
                        <Box sx={{ mb: 3 }}>
                            <TextField fullWidth label="المبلغ المدفوع حالياً" name="deferredAmount" value={deferredAmount} onChange={this.handleInputChange} type="number" sx={{ mb: 1 }} />
                            <Typography sx={{ color: "red", fontWeight: "bold" }}>المبلغ المتبقي: {deferredRemaining} د.ع</Typography>
                        </Box>
                    )}

                    <Typography variant="subtitle1">المجموع الكلي للعدد: <strong>{totalQuantity}</strong></Typography>
                    <Typography variant="subtitle1">المجموع الكلي للسعر: <strong>{totalPrice} د.ع</strong></Typography>

                    <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                        <Button variant="contained" color="primary" size="large" onClick={this.saveInvoice} disabled={isSaving}>
                            {isSaving ? "جاري الحفظ..." : "💾 حفظ الفاتورة"}
                        </Button>
                    </Box>

                    <Dialog open={openProductDialog} onClose={this.handleCloseProductDialog}>
                        <DialogTitle>إضافة مادة جديدة</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="اسم المادة"
                                fullWidth
                                value={newProductName}
                                onChange={(e) => this.setState({ newProductName: e.target.value })}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseProductDialog}>إلغاء</Button>
                            <Button onClick={this.handleSaveNewProduct} variant="contained" color="primary">حفظ</Button>
                        </DialogActions>
                    </Dialog>
                </Paper>
            </Box>
        );
    }
}
